import { LandingPage } from "../components/landing/landing-page";

export default function LandingPageEN() {
  return <LandingPage locale="en" />;
}
